export default __webpack_public_path__ + "static/bastide_image-add0e32a5c567958875185c030d06c5c.jpg";